/** Minimum stroke width (mm) to keep; thinner strokes are removed during SVG processing. */
export const STROKE_MIN_WIDTH_MM = 10;

/** Perceptual color distance (CIE76 ΔE) below which two colors merge into one area. */
export const COLOR_CLUSTER_DELTA_E = 2.5;

/** Max circular hue distance (degrees) for same-family color matching (HSL or LAB). */
export const HUE_GATE_DEGREES = 20;

/**
 * Wider hue gate used with the light-target lightness floor so pastel neighbors
 * (e.g. Figma coral → Hellrosa) can compete.
 */
export const HUE_GATE_LIGHT_DEGREES = 25;

/** HSL saturation below which a color is treated as neutral (skip hue gate). */
export const SATURATION_FLOOR = 0.15;

/** HSL lightness at/above which a target is treated as light/pastel. */
export const LIGHT_TARGET_L = 0.6;

/**
 * For light targets, exclude options darker than targetL − this amount so pastels
 * are not snapped to deep saturated same-hue neighbors (e.g. coral → Reinorange).
 */
export const LIGHT_MAX_DARKEN = 0.12;
